export default __webpack_public_path__ + "static/media/videoPreview.50303cd8.png";